/* ============================================================================
   ANCONA ATELIER 360 - collection presentation density (ancona-atelier-discovery.js)
   Completes the V5 "Agent D" contract: the density toolbar in
   sections/main-collection-product-grid.liquid ships hidden; this module
   reveals and wires it. Presentation-only - it never touches products,
   filters, sort, or the URL.
   - cozy (default) keeps the merchant-configured column count;
     compact raises density via the .av5-density-compact class (CSS in
     assets/ancona-atelier.css, part 92.20).
   - Preference persists to localStorage 'ancona:v1:density' when storage is
     available (probe-tested); denial degrades to per-page state.
   - facets.js replaces #ProductGridContainer.innerHTML on every filter/sort
     change, which restores the server markup (toolbar hidden, cozy pressed).
     A childList MutationObserver re-reveals and re-applies the stored
     preference after each replacement; shopify:section:load re-runs init in
     the theme editor.
   - No-JS customers never see the control (server ships it hidden).
   ============================================================================ */
(function () {
  'use strict';
  if (window.__anconaAtelierDiscovery) return;
  window.__anconaAtelierDiscovery = true;

  var KEY = 'ancona:v1:density';
  var VALID = ['cozy', 'compact'];
  var memory = null; /* fallback when storage is denied */

  function storageOk() {
    try {
      window.localStorage.setItem('ancona:v5:probe', '1');
      window.localStorage.removeItem('ancona:v5:probe');
      return true;
    } catch (e) {
      return false;
    }
  }

  function readPref() {
    if (memory !== null) return memory;
    try {
      var v = window.localStorage.getItem(KEY);
      return VALID.indexOf(v) !== -1 ? v : 'cozy';
    } catch (e) {
      return 'cozy';
    }
  }

  function writePref(v) {
    memory = v;
    if (!storageOk()) return;
    try {
      window.localStorage.setItem(KEY, v);
    } catch (e) {
      /* per-page state only */
    }
  }

  function apply(scope, pref) {
    var grid = scope.querySelector('#product-grid');
    if (grid) {
      grid.classList.toggle('av5-density-compact', pref === 'compact');
      grid.querySelectorAll('[data-av5-card-sizes-cozy]').forEach(function (image) {
        var nextSizes = pref === 'compact'
          ? image.getAttribute('data-av5-card-sizes-compact')
          : image.getAttribute('data-av5-card-sizes-cozy');
        if (nextSizes && image.getAttribute('sizes') !== nextSizes) image.setAttribute('sizes', nextSizes);
      });
    }
    scope.querySelectorAll('[data-av5-density]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-av5-density') === pref ? 'true' : 'false');
    });
  }

  function wire(scope) {
    var toolbar = scope.querySelector('[data-av5-grid-toolbar]');
    if (!toolbar) return;
    toolbar.hidden = false;
    apply(scope, readPref());
    if (toolbar.dataset.anconaDensityWired) return;
    toolbar.dataset.anconaDensityWired = '1';
    toolbar.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('[data-av5-density]') : null;
      if (!btn) return;
      var pref = btn.getAttribute('data-av5-density');
      if (VALID.indexOf(pref) === -1) return;
      writePref(pref);
      apply(document, pref);
      try {
        document.dispatchEvent(new CustomEvent('ancona:density-change', { detail: { density: pref } }));
      } catch (e) {
        /* metric event only */
      }
    });
  }

  var observer = null;

  function observe() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      /* facets.js replaced the container contents: re-reveal + re-apply.
         wire() re-observes nothing (observer watches the stable container). */
      wire(container);
    });
    observer.observe(container, { childList: true });
  }

  function init() {
    wire(document);
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
